import { Reporter007, Reporter007ActionType } from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import { Emitter } from 'nanoevents';
import { ImageEditEventHandlers, ImageEditEvents } from '../events';

export function create007Reporter() {
    const { IMAGE_UPLOAD, IMAGE_GIF_FRAME_UPLOAD, IMAGE_DETECT } = Reporter007ActionType;
    const { SUCCESS, ERROR } = Reporter007;
    const {
        // Upload Events
        UploadError,
        DidUpload,
        UploadGifError,
        DidUploadGif,

        // Detect Events
        ValidateError: DetectError,
        DidValidate: DidDetect,
    } = ImageEditEvents;

    return [
        [DidUpload, () => statusReport007(IMAGE_UPLOAD, SUCCESS)],
        [UploadError, () => statusReport007(IMAGE_UPLOAD, ERROR)],
        [DidUploadGif, () => statusReport007(IMAGE_GIF_FRAME_UPLOAD, SUCCESS)],
        [UploadGifError, () => statusReport007(IMAGE_GIF_FRAME_UPLOAD, ERROR)],
        [DidDetect, () => statusReport007(IMAGE_DETECT, SUCCESS)],
        [DetectError, (err: Error) => statusReport007(IMAGE_DETECT, ERROR, err.message)],
    ] as const;
}

export function createTDWReporter() {}

export function registerReporter(eventBus: Emitter<ImageEditEventHandlers>) {
    const reporter007 = create007Reporter();

    for (const [event, handler] of reporter007) {
        eventBus.on(event, handler);
    }
}
